import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import api from '../api/axios';
import toast from 'react-hot-toast';

const ICONS = {
  interest_received:      '💌',
  interest_accepted:      '✅',
  interest_declined:      '❌',
  profile_viewed:         '👁️',
  shortlisted:            '⭐',
  new_message:            '💬',
  subscription_activated: '🎉',
  subscription_expiring:  '⚠️',
  subscription_expired:   '🔒',
  system:                 '📢',
};

export default function NotificationsPage() {
  const [notifications, setNotifications] = useState([]);
  const [loading,       setLoading]       = useState(true);

  useEffect(() => {
    api.get('/notifications')
      .then(({ data }) => setNotifications(data.notifications || []))
      .finally(() => setLoading(false));
  }, []);

  const markAllRead = async () => {
    await api.put('/notifications/read-all');
    setNotifications(prev => prev.map(n => ({ ...n, is_read: 1 })));
    toast.success('All marked as read');
  };

  const unread = notifications.filter(n => !n.is_read).length;

  return (
    <div className="min-h-screen bg-cream-100">
      <Navbar />
      <div className="max-w-2xl mx-auto px-4 py-8">
        <div className="flex items-center justify-between mb-6">
          <h1 className="font-heading text-2xl font-bold text-gray-900">
            🔔 Notifications {unread > 0 && <span className="text-sm bg-primary text-white px-2 py-0.5 rounded-full ml-2">{unread}</span>}
          </h1>
          {unread > 0 && (
            <button onClick={markAllRead} className="text-sm text-primary hover:underline">
              Mark all read
            </button>
          )}
        </div>

        {loading ? (
          <div className="space-y-3">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="card p-4 animate-pulse flex gap-3">
                <div className="w-10 h-10 bg-gray-200 rounded-full" />
                <div className="flex-1 space-y-2">
                  <div className="h-4 bg-gray-200 rounded w-3/4" />
                  <div className="h-3 bg-gray-200 rounded w-1/2" />
                </div>
              </div>
            ))}
          </div>
        ) : notifications.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-5xl mb-4">🔔</p>
            <p className="text-gray-500">No notifications yet</p>
          </div>
        ) : (
          <div className="space-y-2">
            {notifications.map(n => (
              <div key={n.id}
                className={`card p-4 flex gap-3 transition-colors ${!n.is_read ? 'border-l-4 border-l-primary bg-primary-50' : ''}`}>
                <div className="text-2xl flex-shrink-0">{ICONS[n.type] || '📢'}</div>
                <div className="flex-1">
                  <p className="font-medium text-gray-900 text-sm">{n.title}</p>
                  <p className="text-gray-500 text-sm">{n.body}</p>
                  <p className="text-gray-400 text-xs mt-1">
                    {new Date(n.created_at).toLocaleString('en-IN', { day:'numeric', month:'short', hour:'2-digit', minute:'2-digit' })}
                  </p>
                </div>
                {!n.is_read && <div className="w-2 h-2 bg-primary rounded-full mt-1 flex-shrink-0" />}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
